import React from "react";
import { useParams } from "react-router-dom";

const peopleBehind = [{}];
const SinglePeopleBehind = () => {
  const { id } = useParams();
  // eslint-disable-next-line
  const item = peopleBehind?.find((item) => item.id == id);

  return (
    <div className="App container my-5 w-75">
      <h2 className="heading-font text-center">{item?.name}</h2>
      <img
        src={item?.image}
        alt={item?.name}
        className="w-100 my-4 object-fit-contain"
        style={{ height: "500px" }}
      />
      <div
        className="fw-light fs-6 lh-lg"
        dangerouslySetInnerHTML={{
          __html: item?.detail,
        }}
      />
    </div>
  );
};

export default SinglePeopleBehind;
